import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setFormAction, setSuccessAction } from './actions';
import { useEffect } from 'react';

export const useEditMerchant = (formName) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { values, fields } = useSelector((state) => state.form[formName]);
  const {
    detail: { data },
    edit: { form },
  } = useSelector((state) => state.merchantSetting);
  const formData = {
    ...data,
    ...data?.bank,
    bankId: '',
    mid: '',
    ...form,
    ...values,
  };

  const handleCancel = () => {
    dispatch(setFormAction({ key: 'edit', form: null }));
    dispatch(
      setSuccessAction({
        key: 'bank',
        data: { isChecked: undefined },
        message: '',
      })
    );
    navigate(-1);
  };

  useEffect(() => {
    if (fields && Object.keys(fields)?.length) {
      dispatch(setFormAction({ key: 'edit', form: formData }));
    }
  }, [fields]);

  useEffect(() => {
    let wait = null;
    wait = setTimeout(
      () => dispatch(setFormAction({ key: 'edit', form: formData })),
      250
    );
    return () => clearTimeout(wait);
  }, [values]);

  return { handleCancel };
};
